<div
  class="chat-sidebar"
  [class.expanded]="isExpanded"
  cpdLazyLoadingList
  [disabled]="conversationsLoading"
  [limit]="conversationsLimit"
  [offset]="conversationsOffset"
  [count]="conversationsCount"
  (next)="onNext($event)"
>
  <div class="header">
    <span class="header-text"> Saved Conversations </span>
    <button
      [attr.aria-label]="
        isExpanded ? 'Collapse conversations' : 'Expand conversations'
      "
      type="button"
      mat-icon-button
      class="expand-button"
      (click)="onToggleExpanded()"
      matTooltipPosition="after"
      [matTooltip]="
        isExpanded ? 'Collapse Threads Menu' : 'Expand Threads Menu'
      "
    >
      <fa-icon
        [icon]="['fal', isExpanded ? 'chevron-left' : 'chevron-right']"
      ></fa-icon>
    </button>
  </div>

  <!--
    A11Y.1 28 Sep. Each row is ONE real button. They were div role=button rows
    holding a second button each (nested interactive, WCAG 4.1.2), and every
    conversation's inner button was named "All conversations". The icon is now
    decoration; the row's own text names it.
  -->
  <button
    type="button"
    (click)="onNewChat()"
    class="conversation"
    [class.selected]="!isAllConversations && !currentConversationId"
    matTooltip="Start New Thread"
    matTooltipPosition="after"
  >
    <span class="conversation-button" aria-hidden="true">
      <fa-icon [icon]="['far', 'plus']"></fa-icon>
    </span>
    <span class="nav-text">New Chat</span>
  </button>

  <button
    type="button"
    (click)="onAllConversations()"
    class="conversation"
    [class.selected]="isAllConversations"
    matTooltip="View All Conversations"
    matTooltipPosition="after"
  >
    <span class="conversation-button" aria-hidden="true">
      <fa-icon [icon]="['fas', 'folder']"></fa-icon>
    </span>
    <span class="nav-text">All Conversations</span>
  </button>

  <div class="conversation-list">
    @for (conversation of conversations; track conversation.id) {
      <button
        type="button"
        (click)="onConversationSelect(conversation.id)"
        class="conversation"
        [class.selected]="
          !isAllConversations && currentConversationId === conversation.id
        "
        [attr.aria-current]="
          !isAllConversations && currentConversationId === conversation.id
            ? 'true'
            : null
        "
      >
        <span class="conversation-button" aria-hidden="true">
          <fa-icon [icon]="['far', 'comment-alt']"></fa-icon>
        </span>

        <span class="conversation-text">
          <span class="conversation-header">
            <span class="conversation-title">{{ conversation.title }}</span>
            <span class="conversation-date">
              @if (conversation.updatedAt.split('T')[0] === today) {
                {{ conversation.updatedAt | localTime: 'time' }}
              } @else {
                {{ conversation.updatedAt | localTime: 'date' }}
              }
            </span>
          </span>

          <!-- Repeats the title, so a screen reader would say it twice. -->
          <span class="conversation-message" aria-hidden="true">
            {{ conversation.title }}
          </span>
        </span>
      </button>
    }

    @if (conversationsLoading) {
      @for (item of [].constructor(3); track $index) {
        <cpd-conversation-skeleton></cpd-conversation-skeleton>
      }
    }
  </div>
</div>
